import { render, staticRenderFns } from "./LanguagesAndCountries.vue?vue&type=template&id=40b5a144"
import script from "./LanguagesAndCountries.vue?vue&type=script&lang=js"
export * from "./LanguagesAndCountries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports